export default __webpack_public_path__ + "static/media/instagram.ca47d517.svg";